import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/767b4790/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Tag, Link } from 'carbon-components-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Use a chatbot when a user would benefit from requesting information on-demand
with natural language. They should receive a useful and trustworthy response
related to their question or task.`}</p>
    </PageDescription>
    <h4>{`Status:`}</h4>
    <p>{`Experimental`}</p>
    <h4>{`Maintainer:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vincentsnagg"
      }}>{`Vincent Snagg`}</a></p>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Common use cases</AnchorLink>
      <AnchorLink mdxType="AnchorLink">User needs</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Why a chatbot?</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Supported components</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Chatbot add-on library</AnchorLink>
      <AnchorLink mdxType="AnchorLink">More information</AnchorLink>
    </AnchorLinks>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "44.64285714285714%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAAsElEQVQoz6WSzQqEIBSFe/2eIJ8naNdG3LTtZ2qcBhqxISrzlBecRTSbPHg5qNyPc8UIF7LWUjmtq8GyLLQ3xvzOvZ8V/QN6/yiN/t1j/I7QWhM0CPjsOlRVhaZ5QCl1H+gbpHyBMYY4jpEkCeZ5vpvQ0mrbDkIIFEVxpGyON13DEtZ1jbIsMQwDwYJGdiWlBOccaZpS0tsJnbZtwzRNNGqWZcjzPAzo3P1BP+b57ko7hCLAX8zW+/sAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "chatbot 0",
        "title": "chatbot 0",
        "src": "/static/e49a0c279674c4251b2215fca6ef9cf1/3cbba/chatbot-0.png",
        "srcSet": ["/static/e49a0c279674c4251b2215fca6ef9cf1/7fc1e/chatbot-0.png 288w", "/static/e49a0c279674c4251b2215fca6ef9cf1/a5df1/chatbot-0.png 576w", "/static/e49a0c279674c4251b2215fca6ef9cf1/3cbba/chatbot-0.png 1152w", "/static/e49a0c279674c4251b2215fca6ef9cf1/0b124/chatbot-0.png 1728w", "/static/e49a0c279674c4251b2215fca6ef9cf1/99571/chatbot-0.png 2240w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Shown in Gray 10 Theme</Caption>
    <h2>{`Common use cases`}</h2>
    <p>{`Bots have become an increasingly popular way to solve common business problems across domains, including:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Providing in-context help and guidance`}</strong>{` (e.g., scaling a company’s FAQ or helping a user get started)`}</li>
      <li parentName="ul"><strong parentName="li">{`Triaging or setting priority of cases`}</strong>{` by soliciting information from the user to decrease workload on humans (support tickets, patient symptom severity)`}</li>
      <li parentName="ul"><strong parentName="li">{`Performing common tasks or procedures`}</strong>{` (e.g., pay a bill, transfer money, or assist with electing health benefits)`}</li>
      <li parentName="ul"><strong parentName="li">{`Using natural language to search for information`}</strong>{` (e.g., find specific information like current balance, or dosing instructions for a medication)`}</li>
    </ul>
    <h2>{`Why a chatbot?`}</h2>
    <p>{`Before building a bot, make sure that you have justified it as an appropriate solution by asking yourself these questions:`}</p>
    <ul>
      <li parentName="ul">{`What are the users’ goals?`}</li>
      <li parentName="ul">{`How in-depth is the assistance the user will need?`}</li>
      <li parentName="ul">{`Is your domain better served by human assistance?`}</li>
      <li parentName="ul">{`How is a bot superior to online documentation, contextual support, wizards, etc.?`}</li>
      <li parentName="ul">{`What kind of data sources or abilities can this bot leverage for your business and your users?`}</li>
    </ul>
    <h2>{`User needs`}</h2>
    <h4>{`A user may need:`}</h4>
    <ul>
      <li parentName="ul">{`Access to help at any time`}</li>
      <li parentName="ul">{`An on-demand, relevant answer to a question`}</li>
      <li parentName="ul">{`High quality, consistent information about a product or service`}</li>
    </ul>
    <h4>{`Within a conversation, a user may need:`}</h4>
    <ul>
      <li parentName="ul">{`To provide the bot with more context via structured responses`}</li>
      <li parentName="ul">{`To know what the bot understands, through reflection and confirming questions`}</li>
      <li parentName="ul">{`To identify the most recent and relevant message to improve understanding`}</li>
    </ul>
    <h4>{`Don’t use a chatbot when:`}</h4>
    <ul>
      <li parentName="ul">{`A task could be accomplished more efficiently using a traditional user interface`}</li>
      <li parentName="ul">{`A process is very complex or could take a long time`}</li>
      <li parentName="ul">{`A real human is needed for sensitive or emotional topics`}</li>
    </ul>
    <p>{`See `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/ai/conversation"
      }}>{`IBM Design for Conversational AI`}</a>{` for more information.`}</p>
    <h2>{`Supported components`}</h2>
    <p>{`While conversational interfaces may contain many different kinds of components, Carbon currently offers these components out of the box to help get you up and running quickly. See the Usage tab for information on how to use these components together.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Design status`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Development status`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Chatbot window`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="green" mdxType="Tag">{`Design available`}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Chatbot header`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="green" mdxType="Tag">{`Design available`}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`System message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="green" mdxType="Tag">{`Design available`}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`User message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="green" mdxType="Tag">{`Design available`}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Structured response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="green" mdxType="Tag">{`Design available`}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Chatbot cards`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="green" mdxType="Tag">{`Design available`}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Chatbot text input`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="green" mdxType="Tag">{`Design available`}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Launch button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="green" mdxType="Tag">{`Design available`}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Welcome screen`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="teal" mdxType="Tag">{` Experimental `}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Expandable card`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="teal" mdxType="Tag">{` Experimental `}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Human message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="teal" mdxType="Tag">{` Experimental `}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`List`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="purple" mdxType="Tag">{` Coming soon `}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Launch button chips`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="purple" mdxType="Tag">{` Coming soon `}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Multiple threads menu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="purple" mdxType="Tag">{` Coming soon `}</Tag></td>
          <td parentName="tr" {...{
            "align": null
          }}><Tag type="cool-gray" mdxType="Tag">{` Contribution needed`}</Tag></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Chatbot add-on library`}</h2>
    <p>{`To `}<strong parentName="p">{`add this library to Sketch with Sketch Cloud`}</strong>{`, access the link below and click “Add Library to Sketch.” You will receive updates to chatbot symbols automatically.`}</p>
    <p>{`For `}<strong parentName="p">{`common chatbot sub-patterns, features or experimental components`}</strong>{`, click “Download Document,” open the document, and browse the relevant pages for guidance related to your use case.`}</p>
    <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Sketch library" title="Chatbot Design Kit" aspectRatio="2:1" actionIcon="download" href="https://sketch.cloud/s/k8j5g" mdxType="ResourceCard">
    <MdxIcon name="sketch" mdxType="MdxIcon" />
  </ResourceCard>
    </Column>
    <h2>{`More information`}</h2>
    <p>{`This collection of components is a living resource and the outcome of partnerships with IBM product teams building and testing chatbot interactions. Teams building with chatbots can use these components their work and contribute validated interactions back to the chatbot pattern.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      